import { render, staticRenderFns } from "./LoyaltyMyRewards.vue?vue&type=template&id=aa37256c&scoped=true&"
import script from "./LoyaltyMyRewards.vue?vue&type=script&lang=js&"
export * from "./LoyaltyMyRewards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../nodevenv/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/16/lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa37256c",
  null
  
)

export default component.exports